export const Model = (model: string) => (target: object) => {
  Object.defineProperty(target, model, {
    enumerable: true,
    configurable: true
  });
};
